import { Outlet } from "react-router-dom";
import { AppHeader } from "./PortalLayout";

const REEF_LINKS = [
  { to: "/", key: "home", label: "Home", end: true },
  { to: "/reef", key: "dashboard", label: "The Reef", end: true },
  { to: "/reef/registrations", key: "registrations", label: "Registrations" },
  { to: "/reef/signups", key: "signups", label: "Class Signups" },
  { to: "/reef/requests", key: "requests", label: "Requests" },
  { to: "/reef/classes", key: "classes", label: "Classes" },
  { to: "/reef/sides", key: "sides", label: "Sides" },
  { to: "/reef/students", key: "students", label: "Students" },
  { to: "/reef/billing", key: "billing", label: "Billing" },
  { to: "/reef/api-access", key: "api-access", label: "API access" },
  { to: "/reef/how-it-works", key: "how-it-works", label: "How this site works" },
];

export default function ReefLayout() {
  return (
    <div className="min-h-screen bg-paper">
      <AppHeader links={REEF_LINKS} label="The Reef — Studio Admin" testidPrefix="reef" />
      <main className="mx-auto max-w-6xl px-4 sm:px-6 py-8 sm:py-12">
        <Outlet />
      </main>
    </div>
  );
}
